import React from 'react';
import moment from 'moment-timezone';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import CoachAvatarWithSubject from 'coaching/components/CoachAvatarWithSubject';
import Divider from 'components/Divider';
import Icon from 'components/Icon';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

import { CoachingSessionSchedule } from 'coaching/components/CoachingHomeView/CoachingSessionsBySubjectContainer';

export function CoachSidebarHeader({
  coachName,
  subjectName,
}: {
  coachName?: string;
  subjectName: string;
}) {
  return (
    <>
      <BoxBody size="xsmall">
        <CoachAvatarWithSubject subjectName={subjectName} coachFullName={coachName} />{' '}
      </BoxBody>
      <Divider size="flush" />
    </>
  );
}

export function CoachingSessionScheduleRow({ schedule }: { schedule: CoachingSessionSchedule }) {
  const startDateMoment = moment(schedule.startDateTime);
  return (
    <Row size="xsmall">
      <BoxBody size="xsmall">
        <MediaObject figure="right">
          <Text size="xsmall">
            {schedule.description} {'\u2022'} {startDateMoment.format('dddd')}s at{' '}
            {startDateMoment.format('LT')}
          </Text>
          <Button level="icon">
            <Icon name="chevron-right"></Icon>
          </Button>
        </MediaObject>
      </BoxBody>
      <Divider size="flush" />
    </Row>
  );
}
